import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'tooltip'
})
export class TooltipPipe implements PipeTransform {

  transform(lines: string[]): string {

    let list: string = '';

    lines.forEach(line => {
      list += '• ' + line + '\n';
    });
    console.log(list);

    return list;
  }

}
